import WorkspaceLanding from './components/Navigation/WorkspaceLanding';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import ProductProtectedRoute from './components/ProductProtectedRoute';
import Home from './components/Home';
import Applicants from './components/applicants/Applicants';
import Sourcing from './components/Sourcing';
import Outreach from './components/Outreach/Outreach'; // [NEW] Import Outreach
import Profile from './components/Profile';
import TalentConnectorConsentPage from './components/TalentConnector/TalentConnectorConsentPage';
import TalentConnectorRechargePage from './components/TalentConnector/TalentConnectorRechargePage';
import TalentConnectorAccessPage from './components/TalentConnector/TalentConnectorAccessPage';
import ConnectorProfilePage from './components/TalentConnector/ConnectorProfilePage';
import Login from './components/Login';
import Signup from './components/Signup';
import EmployerOnboarding from './components/EmployerOnboarding';
import EmailVerification from './components/Auth/EmailVerification';
import ForgotPassword from './components/ForgotPassword';
import AcceptTeamInvite from './components/AcceptTeamInvite';
import AssessmentEditor from './components/Assessments/AssessmentEditor';
import LiveAiInterviewEditor from './components/Assessments/LiveAiInterviewEditor';
import AssessmentViewer from './components/Assessments/AssessmentViewer';
import ContactInfoCollector from './components/ContactInfoCollector';
import CalendarCallback from './components/CalendarCallback';
import VerifyCertPage from './components/CertificateVerification/VerifyCert';
import ImportedCVs from './components/ImportedCVs';
import ExternalApps from './components/ExternalApps';
import Payroll from './components/Payroll';
import MyTeam from './components/MyTeam';
import EmployeeLearningPathwayPage from './components/MyTeam/EmployeeLearningPathwayPage';
import OrgIntelligence from './components/OrgIntelligence';
import DataAnalytics from './components/DataAnalytics/DataAnalytics';
import ContractsDocs from './components/ContractsDocs';
import NewInterviewStep from './components/applicants/NewInterviewStep';
import NewAssessmentStep from './components/applicants/NewAssessmentStep';
import Onboarding from './components/Onboarding';
import TalentProfile from './components/TalentProfile/TalentProfile';
import SalesDashboard from './components/Admin/SalesDashboard';
import SelectPlan from './components/SelectPlan';
import OutreachEmailCallback from './components/Outreach/OutreachEmailCallback';
import PublicFormCollection from './components/Onboarding/PublicFormCollection';
import PublicDocumentUpload from './components/Onboarding/PublicDocumentUpload';
import PublicExternalTaskCompletion from './components/Onboarding/PublicExternalTaskCompletion';
import PublicManpowerForm from './components/ManpowerRequest/PublicManpowerForm';
import PublicApprovalPageComp from './components/ManpowerRequest/PublicApprovalPage';
import { ManpowerRequestsPage } from './components/ManpowerRequest';
import CommunityAdminPage from './components/Community/CommunityAdminPage';
import CommunityAccessPage from './components/Community/CommunityAccessPage';
import CommunityViewerPage from './components/Community/CommunityViewerPage';
import CommunityUnsubscribePage from './components/Community/CommunityUnsubscribePage';
import CommunityPublishPage from './components/Community/CommunityPublishPage';
import PublicOfferPage from './components/Offers/PublicOfferPage';

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/payroll-prototype" element={<Navigate to="/payroll" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/onboarding" element={<EmployerOnboarding />} />
              <Route path="/verify-email" element={<EmailVerification />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/accept-invite/:inviteId" element={<AcceptTeamInvite />} />
              <Route path="/calendar-callback" element={<CalendarCallback />} />
              <Route path="/take-assessment/:slug" element={<AssessmentViewer />} />
              <Route path="/fill-contact-info/:slug" element={<ContactInfoCollector />} />
              <Route path="/outreach-email-callback" element={<OutreachEmailCallback />} />
              <Route path="/verify-cert/:slug" element={<VerifyCertPage />} />
              <Route path="/form-collect/:token" element={<PublicFormCollection />} />
              <Route path="/onboarding-docs/:token" element={<PublicDocumentUpload />} />
              <Route path="/onboarding-task-complete/:token" element={<PublicExternalTaskCompletion />} />
              <Route path="/offer/:token" element={<PublicOfferPage />} />
              {/* Public Manpower Request Form - No Auth Required */}
              <Route path="/request-hire/:slug" element={<PublicManpowerForm />} />
              <Route path="/approve-request/:token" element={<PublicApprovalPageComp />} />
              <Route path="/community/access/:token" element={<CommunityAccessPage />} />
              <Route path="/community/feed" element={<CommunityViewerPage />} />
              <Route path="/community/unsubscribe/:token" element={<CommunityUnsubscribePage />} />
              <Route path="/select-plan" element={
                <ProtectedRoute>
                  <SelectPlan />
                </ProtectedRoute>
              } />
              <Route path="/" element={
                <ProtectedRoute>
                  <WorkspaceLanding><Home /></WorkspaceLanding>
                </ProtectedRoute>
              } />
              <Route path="/manpower-requests" element={
                <ProtectedRoute>
                  <ManpowerRequestsPage />
                </ProtectedRoute>
              } />
              <Route path="/applicants" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <Applicants />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/applicants/analytics" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <Applicants />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/sourcing" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="tse">
                    <Sourcing />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/outreach" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="tse">
                    <Outreach />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/sourcing/profile" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="tse">
                    <TalentProfile />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/talent/profile" element={<ProtectedRoute><ConnectorProfilePage /></ProtectedRoute>} />
              <Route path="/connectors/talent/consent" element={<ProtectedRoute><TalentConnectorConsentPage /></ProtectedRoute>} />
              <Route path="/connectors/talent/recharge" element={<ProtectedRoute><TalentConnectorRechargePage /></ProtectedRoute>} />
              <Route path="/connectors/talent/access" element={<ProtectedRoute><TalentConnectorAccessPage /></ProtectedRoute>} />
              <Route path="/connectors/talent" element={<Navigate to="/profile?tab=connections" replace />} />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } />
              <Route path="/imported-cvs" element={
                <ProtectedRoute>
                  <ImportedCVs />
                </ProtectedRoute>
              } />
              <Route path="/external-apps" element={
                <ProtectedRoute>
                  <ExternalApps />
                </ProtectedRoute>
              } />
              <Route path="/payroll" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <Payroll />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/my-team" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <MyTeam />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/nationalization" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <MyTeam />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/my-team/employee/:employeeId/learning-pathway" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <EmployeeLearningPathwayPage />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/my-team/employee/:employeeId" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <MyTeam />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/org-intelligence" element={
                <ProtectedRoute>
                  <OrgIntelligence />
                </ProtectedRoute>
              } />
              <Route path="/data-analytics" element={
                <ProtectedRoute>
                  <DataAnalytics />
                </ProtectedRoute>
              } />
              <Route path="/contracts" element={
                <ProtectedRoute>
                  <ContractsDocs />
                </ProtectedRoute>
              } />
              <Route path="/employee-onboarding" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <Onboarding />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/community" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <CommunityAdminPage />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/community/publish" element={
                <ProtectedRoute>
                  <ProductProtectedRoute requiredProduct="ats">
                    <CommunityPublishPage />
                  </ProductProtectedRoute>
                </ProtectedRoute>
              } />
              <Route path="/assessment-editor/:assessmentId" element={
                <ProtectedRoute>
                  <AssessmentEditor />
                </ProtectedRoute>
              } />
              <Route path="/interview-editor/:assessmentId" element={
                <ProtectedRoute>
                  <LiveAiInterviewEditor />
                </ProtectedRoute>
              } />
              <Route path="/new-interview-step" element={
                <ProtectedRoute>
                  <NewInterviewStep />
                </ProtectedRoute>
              } />
              <Route path="/new-assessment-step" element={
                <ProtectedRoute>
                  <NewAssessmentStep />
                </ProtectedRoute>
              } />
              <Route path="/admin/sales-dashboard" element={
                <ProtectedRoute>
                  <SalesDashboard />
                </ProtectedRoute>
              } />
              <Route path="/team-invite" element={<AcceptTeamInvite />} />
              <Route path="/google-auth" element={<CalendarCallback />} />
              {/* Fallback redirect */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
